// extracted by mini-css-extract-plugin
export var banner = "_hf-0";
export var closeButton = "_hf-2";
export var greenCheckmark = "_hf-3";
export var hereLink = "_hf-4";
export var titleIcon = "_hf-1";